import { LearningWalkthroughOutcome } from "~/gql/graphqlBase.generated";
import { type RecordLearningWalkthroughOutcomeMutationVariables } from "~/gql/mutations/learning.generated";
import { type MyLearningPathQuery } from "~/gql/queries/learning.generated";

export interface EndedWalkthrough {
	conceptId: string | null;
	status: "abandoned" | "completed";
	walkthroughId: string;
}

const findConceptId = (paths: MyLearningPathQuery["myLearningPath"], walkthroughId: string): string | null =>
	paths.flatMap((path) => path.concepts).find((concept) => concept.walkthroughId === walkthroughId)?.conceptId ?? null;

const buildWalkthroughOutcomeVariables = (
	ended: EndedWalkthrough,
	paths: MyLearningPathQuery["myLearningPath"]
): RecordLearningWalkthroughOutcomeMutationVariables | null => {
	const conceptId = ended.conceptId ?? findConceptId(paths, ended.walkthroughId);
	if (!conceptId) return null;
	const outcome =
		ended.status === "completed" ? LearningWalkthroughOutcome.Completed : LearningWalkthroughOutcome.Abandoned;
	return { conceptId, outcome, walkthroughId: ended.walkthroughId };
};

export default buildWalkthroughOutcomeVariables;
